import { render } from "./print-purchase-receipt.vue?vue&type=template&id=68c75180"
import script from "./print-purchase-receipt.vue?vue&type=script&lang=js"
export * from "./print-purchase-receipt.vue?vue&type=script&lang=js"

import "./print-purchase-receipt.vue?vue&type=style&index=0&id=68c75180&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__